const ModelFilter = function (toastr) {
  return {
    require: 'ngModel',
    restrict: 'A',
    link: function (scope, element, attrs, ngModel) {
      // eslint-disable-next-line no-undef
      if (!angular.isString(attrs.modelAsPicklistHuman)) {
        console.error('Unable to update input view')
      }
      if (attrs.modelAsPicklistHuman.length === 0) {
        console.error('Invalid input')
      }
      const filterArgs = attrs.modelAsPicklistHuman
        .split(':')
        .reduce((acc, item, idx) => {
          acc.push(item.trim())
          return acc
        }, [])
      ngModel.$render = function () {
        // eslint-disable-next-line no-undef
        if (angular.isUndefined(scope.picklists)) {
          element.val(ngModel.$modelValue)
        } else {
          let idx = 0
          let success = false
          const pickLists = scope.picklists[filterArgs[1]]
            ? scope.picklists[filterArgs[1]].picklist
            : []
          for (idx; idx < pickLists.length; idx++) {
            const pick = pickLists[idx]
            const scopePath = ['storyObj', filterArgs[0]].join('.')
            if (pick.id === scope.$eval(scopePath)) {
              // eslint-disable-line eqeqeq
              element.val(pick.text)
              success = true
              break
            }
          }
          if (!success) {
            element.val(ngModel.$modelValue)
          }
        }
      }
    },
  }
}

export default ['$filter', 'toastr', ModelFilter]
